import script from "./AdminProductTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductTableRow.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductTableRow.vue?vue&type=style&index=0&id=00056884&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00056884"]])

export default __exports__